import {CommonMessages} from '../common.messages';

export const PlatformFrontendAddMessages = {
    PlatformFrontendCreationFailed: {
        key: 'PlatformFrontendCreationFailed',
        message: 'Error while processing request. Unable to create a Platform Frontend.'
    },
    PlatformFrontendCreationSucceed: {
        key: 'PlatformFrontendCreationSucceed',
        message: 'Platform Frontend is successfully created.'
    },
    PlatformFrontendListFailed: {
        key: 'PlatformFrontendListFailed',
        message: 'Error while processing request. Unable to list Platform Frontends.'
    },
    PlatformFrontendListDeletableFailed: {
        key: 'PlatformFrontendListDeletableFailed',
        message: 'Error while processing request. Unable to list deletable Platform Frontends.'
    },
    PlatformFrontendNoDeletableData: {
        key: 'PlatformFrontendNoDeletableData',
        message: 'There are no deletable Platform Frontends! All of them may have been assigned to a feed or a bundle.'
    },
    PlatformFrontendDeletionFailed: {
        key: 'PlatformFrontendDeletionFailed',
        message: 'Error while processing request. Unable to delete a Platform Frontend.'
    },
    PlatformFrontendDeletionSucceed: {
        key: 'PlatformFrontendDeletionSucceed',
        message: 'Platform Frontend is successfully deleted.'
    },
    PlatformFrontendUpdateFailed: {
        key: 'PlatformFrontendUpdateFailed',
        message: 'Error while processing request. Unable to update a Platform Frontend.'
    },
    PlatformFrontendUpdateSucceed: {
        key: 'PlatformFrontendUpdateSucceed',
        message: 'Platform Frontend is successfully updated.'
    },
    ...CommonMessages
};
